export const NestedLevelShift = 24